import React, { Component } from 'react';
import NProgress from 'nprogress'

import Grid from '../Grid';

import Train from '../../services/train.js';
import Notification from '../../services/Notification.js'
import StringUtils from '../../services/StringUtils.js'

class Popular extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      popular: []
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillReceiveProps(newProps) {
  }

  fetchTopElements(popular, type) {
    return Train.fetchPopularElements({popular, type})
    .then((result) => {
      let popularElements = {popular};
      popularElements[type] = result[type];
      return popularElements;
    });
  }

  fetchData() {
    NProgress.start();

    Train.fetchPopularLists()
    .then((popular) => {
      this.setState({popular: popular});
      NProgress.done();
    })
    .catch((e) => {
      this.setState({popular: []});
      NProgress.done();
      Notification.show('Error loading popular lists', 'error');
    });
  }

  title(popular, type) {
    return StringUtils.titleize(popular + ' top ' + type);
  }

  render() {

    let popular = this.state.popular;

    if (!popular)
      return null;

    let grids = popular.map((element) => {
      if (element.artists) {
        return <Grid key={element.popular + '.artists'} carousel={true} title={this.title(element.popular, 'artists')} mappable={true} mapContext="popular" mapSearchTerm={element.popular} mapType="top_artists" playable={true} type="artist"  elements={element.artists} />;
      } else if (element.tracks) {
        return <Grid key={element.popular + '.tracks'} carousel={true} title={this.title(element.popular, 'tracks')} playable={true} type="track" elements={element.tracks} />;
      } else {
        return null;
      }
    });

    return (
      <div>
        {grids}
      </div>
    );

  }
}

export default Popular;



// WEBPACK FOOTER //
// ./src/js/components/explore/Popular.jsx